import jwtDecode from "jwt-decode";
import api from "../configs/apiConfig";
import axios from "axios";

export const getToken = () => {
    const token = localStorage.getItem("authToken");
    if (token) {
        return token;
    }
    return null;
};

// verify the token via jwt-decode
export const verifyToken = (token: string) => {
    const decodedToken: any = jwtDecode(token);
    if (decodedToken && decodedToken?.exp)
        return decodedToken.exp > Date.now() / 1000;
    return false;
};

// set or remove JWT token session
export const setJwtSession = (mode: "SET" | "REM", token?: string) => {
    if (mode === "SET" && token) {
        localStorage.setItem("authToken", token);
        api.defaults.headers.common.Authorization = `Bearer ${token}`;
    } else {
        localStorage.removeItem("authToken");
        delete api.defaults.headers.common.Authorization;
    }
};

export const setRefreshToken = (mode: "SET" | "REM", token?: string) => {
    if (mode === "SET" && token) {
        localStorage.setItem("refreshToken", token);
    } else {
        localStorage.removeItem("refreshToken");
    }
};

export const refreshAuthToken = async (username: string) => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (refreshToken) {
        try {
            const result = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/getNewAuthToken`,
                {
                    username,
                    refreshToken,
                },
            );
            if (result.data && result.data?.success) {
                const newAccessToken = result.data.accessToken;
                setJwtSession("SET", result.data.accessToken);
                return newAccessToken;
            } else {
                return null;
            }
        } catch (error) {
            return null;
        }
    } else {
        return null;
    }
};
